import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import styles from '../css/Login.module.css';
import { API_CONFIG } from '../apiConfig'; 

const LOGIN_URL = API_CONFIG.LOGIN || `${API_CONFIG.BASE_URL}/api/auth/login/`;

const Login = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post(LOGIN_URL, { 
                username: username, 
                password: password 
            }, { withCredentials: true });

            if (response.status === 200) {
                const userData = { 
                    username: response.data.username,
                    csrftoken: response.data.csrftoken 
                };
                // Esto guarda la sesión en el navegador
                localStorage.setItem('user_session', JSON.stringify(userData));
                onLoginSuccess(userData); 
            }
        } catch (err) {
            const msg = err.response?.data?.detail || 'Credenciales inválidas.';
            setError(msg);
            setLoading(false);
        }
    };

    return (
        <div className={styles.viewportWrapper}>
            {/* FONDO AURORA */}
            <div className={styles.auroraContainer}>
                <div className={`${styles.auroraElement} ${styles.one}`}></div>
                <div className={`${styles.auroraElement} ${styles.two}`}></div>
                <div className={`${styles.auroraElement} ${styles.three}`}></div>
            </div>

            <div className={styles.techGrid}></div>

            <main className={styles.contentOverlay}>
                <div className={styles.loginLayout}>
                    
                    {/* SECCIÓN IZQUIERDA: BRANDING */}
                    <div className={styles.brandingSection}>
                        <div className={styles.logoBadge}>
                            <img src="/Logo-Iump-Concon.ico" alt="Logo" />
                            <span>IUMP Digital</span>
                        </div>
                        
                        <h1 className={styles.mainTitle}>
                            <span>ADMIN</span>
                            <span className={styles.gradientText}>AVISOS</span>
                        </h1>
                        
                        <div className={styles.statsGrid}>
                            <div className={styles.statCard}>
                                <span className={styles.num}>2.0.6</span>
                                <span className={styles.label}>Versión Engine</span>
                            </div>
                            <div className={styles.statCard}>
                                <span className={`${styles.num} ${styles.live}`}>Live</span>
                                <span className={styles.label}>Servidor Activo</span>
                            </div>
                        </div>
                    </div>

                    {/* SECCIÓN DERECHA: FORMULARIO */}
                    <div className={styles.authSection}>
                        <div className={styles.cyberCard}>
                            <div className={styles.glowBorder}></div>
                            
                            <form className={styles.innerContent} onSubmit={handleSubmit}>
                                <div className={styles.formHeader}>
                                    <h2>Autenticación</h2>
                                    <div className={styles.headerBar}></div>
                                </div>

                                <div className={styles.inputGroup}>
                                    <label>Identidad de Usuario</label>
                                    <div className={styles.relativeInput}>
                                        <i className="pi pi-user"></i>
                                        <input 
                                            type="text" 
                                            placeholder="Usuario o Correo"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            className={styles.cyberInput}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className={styles.inputGroup}>
                                    <label>Contraseña</label>
                                    <div className={styles.relativeInput}>
                                        <i className="pi pi-lock"></i>
                                        <input 
                                            type="password" 
                                            placeholder="••••••••"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            className={styles.cyberInput}
                                            required
                                        />
                                    </div>
                                </div>

                                <button type="submit" className={styles.accessButton} disabled={loading}>
                                    <span className={styles.btnText}>
                                        {loading ? 'VERIFICANDO...' : 'INICIAR SESIÓN'}
                                        <i className={loading ? "pi pi-spin pi-spinner" : "pi pi-shield"}></i>
                                    </span>
                                    <div className={styles.btnFlare}></div>
                                </button>

                                {error && <p className={styles.errorMessage}>{error}</p>}

                                <Link to="/" className={styles.backLink}>
                                    <i className="pi pi-arrow-left"></i> Volver al Inicio
                                </Link>
                            </form>
                        </div>
                    </div>
                </div>
            </main>

            <footer className={styles.loginFooter}>
                <div className={styles.footerInfo}>
                    <div className={styles.statusDot}></div>
                    <span>IUMP Concón © 2026 • Chile</span>
                </div>
                <div className={styles.footerLinks}>
                    <span>Soporte TI</span>
                    <span className={styles.version}>v2.0.6-stable</span>
                </div>
            </footer>
        </div>
    );
};

export default Login;